import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const POST_TASK_REQUEST = 'sherrinford/Project/Management/POST_TASK_REQUEST'
export const POST_TASK_SUCCESS = 'sherrinford/Project/Management/POST_TASK_SUCCESS'
export const POST_TASK_ERROR = 'sherrinford/Project/Management/POST_TASK_ERROR'

export const PUT_REVIEW_REQUEST = 'sherrinford/Project/Management/PUT_REVIEW_REQUEST'
export const PUT_REVIEW_SUCCESS = 'sherrinford/Project/Management/PUT_REVIEW_SUCCESS'
export const PUT_REVIEW_ERROR = 'sherrinford/Project/Management/PUT_REVIEW_ERROR'

export const GET_REVIEW_REQUEST = 'sherrinford/Project/Management/GET_REVIEW_REQUEST'
export const GET_REVIEW_SUCCESS = 'sherrinford/Project/Management/GET_REVIEW_SUCCESS'
export const GET_REVIEW_ERROR = 'sherrinford/Project/Management/GET_REVIEW_ERROR'

export const SET_FILTER_BY_RATING = 'sherrinford/project/detail/SET_FILTER_BY_RATING'

export const SET_FILTER_SORT_REVIEW = 'sherrinford/project/detail/SET_FILTER_SORT_REVIEW'

const initialState = {
  isLoading: false,
  review: {
    count: 0,
    qs: {
      skip: 0,
      limit: 0,
      sort: {
        createdAt: 'DESC',
      },
    },
    rows: [],
  },
  filterReview: {
    rating: 0,
  },
  sort: 'DESC',
}

export default createReducer(initialState, {
  [POST_TASK_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_TASK_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_TASK_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [PUT_REVIEW_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PUT_REVIEW_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_REVIEW_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_REVIEW_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_REVIEW_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    review: data,
  }),
  [GET_REVIEW_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [SET_FILTER_BY_RATING]: (state, data) => ({
    ...state,
    filterReview: {
      ...state.filterReview,
      rating: data,
    },
  }),
  [SET_FILTER_SORT_REVIEW]: (state, data) => ({
    ...state,
    sort: data,
  }),
})

export const putReviewEligible = (payloads, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      PUT_REVIEW_REQUEST,
      PUT_REVIEW_SUCCESS,
      PUT_REVIEW_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: '/order_review/eligible',
      authorization: `${token}`,
      payloads,

    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const generateTasks = (payloads, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_TASK_REQUEST,
      POST_TASK_SUCCESS,
      POST_TASK_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/task',
      authorization: `${token}`,
      payloads,

    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export function getOrderReview(searchParam, cb = () => {}, populateParam = null, sort = 'DESC') {
  return {
    type: [
      GET_REVIEW_REQUEST,
      GET_REVIEW_SUCCESS,
      GET_REVIEW_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/order_review',
      qs: {
        search: JSON.stringify(searchParam),
        sort: {
          updatedAt: sort,
        },
        populate: populateParam,
      },
    },
    nextAction: res => cb(res),
  }
}

export const setFilterByRating = data => ({
  type: [SET_FILTER_BY_RATING],
  payload: data,
})

export const setFilterSortReview = data => ({
  type: [SET_FILTER_SORT_REVIEW],
  payload: data,
})
